export default "__VITE_ASSET__Bgx4FVB___"